var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1930_19896)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.954 5.25C12.954 5.05109 12.875 4.86032 12.7343 4.71967C12.5937 4.57902 12.4029 4.5 12.204 4.5H2.25C1.65326 4.5 1.08097 4.73705 0.65901 5.15901C0.237053 5.58097 0 6.15326 0 6.75L0 21.75C0 22.3467 0.237053 22.919 0.65901 23.341C1.08097 23.7629 1.65326 24 2.25 24H17.25C17.8467 24 18.419 23.7629 18.841 23.341C19.2629 22.919 19.5 22.3467 19.5 21.75V11.796C19.5 11.5971 19.421 11.4063 19.2803 11.2657C19.1397 11.125 18.9489 11.046 18.75 11.046C18.5511 11.046 18.3603 11.125 18.2197 11.2657C18.079 11.4063 18 11.5971 18 11.796V21.75C18 21.9489 17.921 22.1397 17.7803 22.2803C17.6397 22.421 17.4489 22.5 17.25 22.5H2.25C2.05109 22.5 1.86032 22.421 1.71967 22.2803C1.57902 22.1397 1.5 21.9489 1.5 21.75V6.75C1.5 6.55109 1.57902 6.36032 1.71967 6.21967C1.86032 6.07902 2.05109 6 2.25 6H12.204C12.4029 6 12.5937 5.92098 12.7343 5.78033C12.875 5.63968 12.954 5.44891 12.954 5.25Z",
    fill: "#1C2026"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0.75C24 0.551088 23.921 0.360322 23.7803 0.21967C23.6396 0.0790176 23.4489 0 23.25 0L15.75 0C15.5511 0 15.3603 0.0790176 15.2196 0.21967C15.079 0.360322 15 0.551088 15 0.75C15 0.948912 15.079 1.13968 15.2196 1.28033C15.3603 1.42098 15.5511 1.5 15.75 1.5H21.4395L9.21897 13.719C9.14924 13.7887 9.09392 13.8715 9.05619 13.9626C9.01845 14.0537 8.99902 14.1514 8.99902 14.25C8.99902 14.3486 9.01845 14.4463 9.05619 14.5374C9.09392 14.6285 9.14924 14.7113 9.21897 14.781C9.2887 14.8507 9.37149 14.906 9.4626 14.9438C9.5537 14.9815 9.65136 15.0009 9.74997 15.0009C9.84859 15.0009 9.94624 14.9815 10.0373 14.9438C10.1285 14.906 10.2112 14.8507 10.281 14.781L22.5 2.5605V8.25C22.5 8.44891 22.579 8.63968 22.7196 8.78033C22.8603 8.92098 23.0511 9 23.25 9C23.4489 9 23.6396 8.92098 23.7803 8.78033C23.921 8.63968 24 8.44891 24 8.25V0.75Z",
    fill: "#1C2026"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1930_19896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxArrowUpRight);
export default __webpack_public_path__ + "static/media/box-arrow-up-right.4b2c5460809273bb0956d38ec9601263.svg";
export { ForwardRef as ReactComponent };